import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const TextileSection = ({ title, description, isReversed = false, image, link, linkText }) => (
  <div className={`flex flex-col md:flex-row items-center gap-8 py-16 ${isReversed ? 'md:flex-row-reverse' : ''}`}>
    <div className="w-full md:w-1/2 space-y-4">
      <h3 className="text-2xl md:text-3xl font-semibold text-gray-900">{title}</h3>
      <p className="text-gray-600 leading-relaxed">{description}</p>
      {link && (
        <a 
          href={link} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="inline-flex items-center text-primaryBlue hover:text-primaryBlue/80 font-medium transition-colors duration-300"
        >
          {linkText || 'Visit Website'}
          <svg
            className="ml-2 w-5 h-5 transition-transform duration-300 group-hover:translate-x-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            />
          </svg>
        </a>
      )}
    </div>
    <div className="w-full md:w-1/2 h-64 md:h-96 bg-gray-200 rounded-lg overflow-hidden">
      <img 
        src={image} 
        alt={title} 
        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
      />
    </div>
  </div>
);

const Textile = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="relative h-[60vh] bg-primaryNavy">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ 
            backgroundImage: 'url(/images/tekstil.jpg)',
          }}
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 flex items-center justify-center text-center">
          <div className="max-w-4xl mx-auto px-4">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
              {t('textile.hero.title')}
            </h1>
            <p className="text-lg md:text-xl text-white/90">
              {t('textile.hero.description')}
            </p>
          </div>
        </div>
      </div>

      {/* Content Sections */}
      <div className="max-w-7xl mx-auto px-4 py-16 space-y-16">
        <TextileSection
          title={t('textile.iplik.title')}
          description={t('textile.iplik.description')}
          image="/images/iplikfoto.jpg"
        />
        <div className="border-t border-gray-200" />
        <TextileSection
          title={t('textile.kumas.title')}
          description={t('textile.kumas.description')}
          image="/images/kumasfoto.jpg"
          isReversed={true}
        />
        <div className="border-t border-gray-200" />
        <TextileSection
          title={t('textile.giyim.title')}
          description={t('textile.giyim.description')}
          image="/images/amarislogo.png"
          link="https://amariswear.com/"
          linkText="Amaris Wear"
        />
        <div className="border-t border-gray-200" />
        <TextileSection
          title={t('textile.kikukai.title')}
          description={t('textile.kikukai.description')}
          image="/images/kikukai.png"
          isReversed={true}
          link="https://amariswear.com/kiku-kai"
          linkText="Kiku & Kai"
        />
      </div>
    </div>
  );
};

export default Textile; 